import { Injectable } from '@angular/core';

import { BaseService } from './base.service';
import { InspectionPlanModel } from '../model/inspection-plan.model';
import { InspectionPlanItemModel } from '../model/inspection-plan-item.model';

@Injectable()
export class InspectionPlanService {

  path = '/inspection-plan/';
  pathItem = '/inspection-plan-item/';

  constructor(private baseService: BaseService) {}

  getPaginated(query) {
    return this.baseService.get(this.path, '', query);
  }

  findByPk(id: string) {
    return this.baseService.get(this.path, id);
  }

  post(list: InspectionPlanModel) {
    return this.baseService.post(this.path, '', list);
  }

  put(list: InspectionPlanModel) {
    return this.baseService.put(this.path, '', list);
  }

  deleteList(id: string) {
    return this.baseService.delete(this.path, id);
  }

  saveList(list: InspectionPlanModel) {
    if (list.id) return this.put(list); else return this.post(list);
  }

  // For Items

  postItem(item: InspectionPlanItemModel) {
    return this.baseService.post(this.pathItem, '', item);
  }

  putItem(item: InspectionPlanItemModel) {
    return this.baseService.put(this.pathItem, '', item);
  }

  deleteItem(id: string) {
    return this.baseService.delete(this.pathItem, id);
  }

  saveItem(item: InspectionPlanItemModel) {
    if (item.id) return this.putItem(item); else return this.postItem(item);
  }

  // For Items With Unconformities

  withUnconformities(items: any[]) {
    return this.baseService.post(this.path, 'with-unconformities', items);
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/inspection-plan.service.ts